import * as React from "react";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { Grid, IconButton, Toolbar } from "@mui/material";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import CountUp from "react-countup";
import "./style.css";
import { Helmet } from "react-helmet-async";
import LineChartHome from "../Charts/LineChart";
import { StackedBarChartPerInstitution } from "../Charts/BarChart Per Institution";
import DenseTable from "../../ui/DenseTable";
import InvestmentInterestInsightTable from "../Charts/TableChart";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const columns = [
  {
    id: "code",
    label: "Code",
    minWidth: 170,
    align: "left",
  },
  {
    id: "institution",
    label: "Institution",
    minWidth: 170,
    align: "left",
  },
  {
    id: "tenure",
    label: "Tenure",
    minWidth: 170,
    align: "left",
  },
  {
    id: "purchase_date",
    label: "Purchase Date",
    minWidth: 170,
    align: "left",
  },
  {
    id: "maturity_date",
    label: "Maturity Date",
    minWidth: 170,
    align: "left",
  },
  {
    id: "rate_type",
    label: "Rate Type",
    minWidth: 170,
    align: "left",
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => value.toLocaleString(),
  },
  {
    id: "total_interest",
    label: "Total Interest",
    minWidth: 170,
    valueFormatter: ({ value }) => value.toLocaleString(),
  },
  {
    id: "fair_value",
    label: "Fair Value",
    minWidth: 170,
  },
];
function showMonthData(
  id,
  code,
  institution,
  tenure,
  purchase_date,
  maturity_date,
  rate_type,
  cost,
  total_interest,
) {
  const fair_value =
    rate_type === "discount rate"
      ? cost.toLocaleString()
      : (cost + total_interest).toLocaleString();
  return {
    id,
    code,
    institution,
    tenure,
    purchase_date,
    maturity_date,
    rate_type,
    cost,
    total_interest,
    fair_value,
  };
}
function CompactSummaryCard({
  label,
  value,
  prefix = "",
  accent = "#355c80",
  danger = false,
  count = false,
}) {
  return (
    <Card
      elevation={0}
      sx={{
        width: 185,
        height: 58,
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        borderLeft: `4px solid ${danger ? "#d33115" : accent}`,
        background: danger
          ? "linear-gradient(135deg, rgba(211,49,21,0.07) 0%, #ffffff 75%)"
          : "linear-gradient(135deg, rgba(53,92,128,0.08) 0%, #ffffff 75%)",
        boxShadow: "0 7px 18px rgba(15,23,42,0.055)",
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 24px rgba(15,23,42,0.09)",
        },
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          p: "7px 10px !important",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: 9.5,
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: danger ? "#b91c1c" : "#3D4F58",
            lineHeight: 1.1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            mt: 0.35,
            fontSize: count ? 16 : 12.5,
            fontWeight: 950,
            color: danger ? "#991b1b" : "#1e293b",
            lineHeight: 1.1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`${prefix}${value}`}
        >
          <CountUp
            start={0}
            end={Number(value || 0)}
            duration={2.2}
            prefix={prefix}
            separator=","
            decimals={count ? 0 : 2}
          />
        </Typography>
      </CardContent>
    </Card>
  );
}
export default function Analytics() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [filterData] = React.useState({
    interest_charged_start: "",
    interest_charged_end: "",
  });
  const totalCost = [];
  const totalinterest_charged = [];
  const totalInterestUnEarned = [];
  const accumInterest = [];
  const fairValue = [];

  function createData(
    id,
    code,
    certificate_number,
    institution,
    investment_type,
    regulator,
    rate,
    purchase_date,
    maturity_date,
    tenure,
    cost,
    impairment,
    total_interest,
    daily_interest,
    rate_type,
  ) {
    //  we are check whether an asset is exhausted or not

    let status = moment(maturity_date) > moment() ? "Active" : "Matured";
    // ----------------------------------------------------------------
    const date2 = moment();
    const date1 = moment(purchase_date);
    let days_earned = date2.diff(date1, "days") + 1;
    let interest_charged = days_earned * daily_interest;
    let days_unearned = tenure - days_earned;
    let cumulative_interest = days_earned * daily_interest;
    let interest_unearned = days_unearned * daily_interest;
    let fair_value =
      rate_type === "interest rate"
        ? cost + cumulative_interest - impairment
        : cost - impairment;
    // ! WE DON'T CHARGE DEPN ON LAND

    // ! Revalued Started here -----------------------//!

    //! ------------Revalued ended here-------------------------///!

    // !------------start------------------------------------
    // checking if the asset has been exhausted;
    // if (cost - cumulative_interest < 1) {
    //   interest_unearned = 0;
    // }
    if (status === "Matured") {
      days_earned = moment(maturity_date).diff(purchase_date, "days");
      days_unearned = 0;

      cumulative_interest = days_earned * daily_interest;
      interest_unearned = days_unearned * daily_interest;
      interest_charged = 0;
      fair_value =
        rate_type === "interest rate"
          ? cost + cumulative_interest - impairment
          : cost - impairment;
    }
    // !------------- Exhausted Checking End---------------------------

    // ! things to do when the interest_charged start date and end date are all selected--------------//Start

    if (filterData.interest_charged_start && filterData.interest_charged_end) {
      if (
        filterData.interest_charged_start &&
        filterData.interest_charged_end &&
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) < moment(filterData.interest_charged_start) &&
        status === "Matured"
      ) {
        cumulative_interest = cost;
        interest_unearned = 0;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }

      if (moment(filterData.interest_charged_end) < moment(purchase_date)) {
        cost = 0;
        fair_value = 0;
        interest_unearned = 0;
        cumulative_interest = 0;
        days_earned = 0;
        days_unearned = 0;
        interest_charged = 0;

        status = "investment was not available then";
      }

      // check if the interest_charged end date is within the exhausted date //! Start------------

      if (
        moment(purchase_date) <= moment(filterData.interest_charged_start) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      // ----------!End!----------------//!

      // we will check if the purchase date is less than the start date and the exhaustion date  is greater than the start date and also the exhaustion date is less than the end date//! start

      if (
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        const diff = moment(maturity_date).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );
        //! this is where I did the negative changes
        days_earned = cummDateDiff;
        days_unearned = tenure - cummDateDiff;
        interest_unearned = (tenure - cummDateDiff) * daily_interest;
        cumulative_interest = cummDateDiff * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = diff * daily_interest;
        // ! the change was done here
        // ! I am looking for a scenario where the purchase date is less than the start and the maturity is less than the end
      }

      // ----------------------//!End---------------------
      if (moment(maturity_date) < moment(filterData.interest_charged_start)) {
        interest_unearned = 0;
        cumulative_interest = days_earned * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }
      // if (
      //   moment(purchase_date) < moment(filterData.interest_charged_start) &&
      //   moment(maturity_date) <= moment(filterData.interest_charged_end)
      // ) {
      //   days_earned = tenure;
      // }
      // we will check if the purchase date is greater than the start date and the exhaustion date is greater than the end date//!start
      if (
        moment(purchase_date) > moment(filterData.interest_charged_start) &&
        moment(purchase_date) <= moment(filterData.interest_charged_end) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
        // ! another change too was done here, equal sign was added to the second check
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      if (
        moment(purchase_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        //  we will check if the purchase date is greater than the start date and the exhaustion date is less than the end date;
        // if both the purchase and the exhaustion date are in btn the start and end date;
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff;
        days_unearned = 0;
        interest_unearned = 0;
        cumulative_interest = tenure * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        const diff = moment(maturity_date).diff(moment(purchase_date), "days");
        interest_charged = diff * daily_interest;
      }
    }
    // -----------------------End of instance-------------------//!End
    // ! we will be catching all disposed assets instances here

    //  we will check if the disposal happened before the start date

    // we will check if the disposal date is greater than the start date and is less than or equal to the end date;

    // ! Depn start and depn end.-----------------------// End

    totalCost.push(cost);
    totalinterest_charged.push(interest_charged);
    totalInterestUnEarned.push(interest_unearned);
    accumInterest.push(cumulative_interest);
    fairValue.push(fair_value);
    return {
      id,
      code,
      certificate_number,
      institution,
      investment_type,
      regulator,
      rate,
      purchase_date,
      maturity_date,
      tenure,
      days_earned,
      days_unearned,
      cost,
      cumulative_interest,
      interest_unearned,
      impairment,
      fair_value,
      total_interest,
      interest_charged,
      daily_interest,
      status,
      rate_type,
    };
  }
  const approvedInvestments = useSelector((state) => state.approvedInvestment);
  const [data, setData] = React.useState(approvedInvestments);
  const [activeInvestments, setActiveInvestments] = React.useState([]);
  React.useEffect(() => {
    const filteredInvestments = data.filter(
      (investment) => moment(investment.maturity_date) > moment(),
    );
    setActiveInvestments(filteredInvestments);
  }, [data]);

  const rows = activeInvestments.map((data) =>
    createData(
      data._id,
      data.code,
      data.certificate_number,
      data.institution,
      data.investment_type,
      data.regulator,
      data.rate,
      moment(data.purchase_date).format("YYYY-MM-DD"),
      moment(data.maturity_date).format("YYYY-MM-DD"),
      data.tenure,
      data.cost,
      data.impaired_amount,
      data.total_interest,
      data.daily_interest,
      data.rate_type,
    ),
  );
  React.useEffect(() => {
    setData(approvedInvestments);
  }, [approvedInvestments]);
  const monthStats = useSelector((state) => state.month_stats);

  // ! FETCH ALL NEEDED INFOR HERE

  const totalInvestmentCost = totalCost.reduce((acc, val) => acc + val, 0);

  const totalInvestmentInterestUnEarned = totalInterestUnEarned.reduce(
    (acc, val) => acc + val,
    0,
  );
  const totalInvestmentAccumInterest = accumInterest.reduce(
    (acc, val) => acc + val,
    0,
  );

  const totalInvestmentFairValue = fairValue.reduce((acc, val) => acc + val, 0);
  const totalInterest = rows.reduce((acc, obj) => acc + obj.total_interest, 0);

  // const totalInterest = rows.reduce((acc, obj) => acc + obj.total_interest, 0);
  const rows2 = monthStats.map((data) =>
    showMonthData(
      data._id,
      data.code,
      data.institution,
      data.tenure,
      moment(data.purchase_date).format("MM-DD-YYYY"),
      moment(data.maturity_date).format("MM-DD-YYYY"),
      data.rate_type,
      data.cost.toFixed(2) * 1,
      data.total_interest.toFixed(2) * 1,
    ),
  );
  return (
    <div style={{ width: "100%" }}>
      <Helmet title="Dashboard | Portfolio Manager" />

      <Grid spacing={2} sx={{ flexGrow: 1 }}>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            spacing={1.3}
            sx={{
              mb: 2,
            }}
          >
            <Grid item>
              <CompactSummaryCard
                label="Active Investments"
                value={rows.length}
                count
                accent="#355c80"
              />
            </Grid>

            <Grid item>
              <CompactSummaryCard
                label="Total Cost"
                value={totalInvestmentCost}
                prefix="GHS "
                accent="#355c80"
              />
            </Grid>

            <Grid item>
              <CompactSummaryCard
                label="Cumulative Interest"
                value={totalInvestmentAccumInterest}
                prefix="GHS "
                accent="#17b859"
              />
            </Grid>

            <Grid item>
              <CompactSummaryCard
                label="Interest Unearned"
                value={totalInvestmentInterestUnEarned}
                prefix="GHS "
                accent="#f59e0b"
              />
            </Grid>

            <Grid item>
              <CompactSummaryCard
                label="Fair Value"
                value={totalInvestmentFairValue}
                prefix="GHS "
                accent="#355c80"
              />
            </Grid>

            <Grid item>
              <CompactSummaryCard
                label="Total Interest"
                value={totalInterest}
                prefix="GHS "
                accent="#17b859"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LineChartHome />
        <InvestmentInterestInsightTable />
      </div>
      <Paper
        elevation={0}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: "30px",
          backgroundColor: "transparent",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <DonutChart /> */}
      </Paper>
      {monthStats.length > 0 && (
        <Paper
          elevation={0}
          onClick={handleClickOpen}
          style={{
            // backgroundColor: "#C9CED6",

            display: "flex",

            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <Typography
            className="blinking-text"
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              padding: "5px",
            }}
          >
            {monthStats.length} Investments will mature this month.
            <strong style={{ fontSize: "16px" }}>Click me for details</strong>
          </Typography>
        </Paper>
      )}
      <div style={{ width: "100%", height: "300px" }}>
        <StackedBarChartPerInstitution />
      </div>

      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative", backgroundColor: "#355c80" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Close
              </Typography>
            </Toolbar>
          </AppBar>
          <Paper style={{ width: "100%" }}>
            <DenseTable
              headers={columns}
              rows={rows2}
              filename="matured investments"
            />
          </Paper>
        </Dialog>
      </div>
    </div>
  );
}
